import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import VideoSection from "../../Components/VideoSection/VideoSection";
import LessonSection from "../../Components/LessonSection/LessonSection";
import MenuTab from "../../Components/MenuTab/MenuTab";
import ClassProgress from "../../Components/ClassProgress/ClassProgress";
import ClassLoading from "../../Components/ClassLoading/ClassLoading";
import axiosInstance from "../../Config/axiosConfig";

function PreviewClass() {
  const { classId } = useParams();
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [classInfo, setClassInfo] = useState({ description: "", resource: "", duration: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const accessToken = localStorage.getItem("accessToken");
    const storedDeviceId = localStorage.getItem("deviceId");
    const storedUserIp = localStorage.getItem("userIp");

    axiosInstance.get(`/class/get-class/${classId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
          UserDevice: storedDeviceId,
          UserIPAddress: storedUserIp,
        },
      })
      .then((response) => {
        const data = response.data;
        console.log("Response data:", data); // Log the response data
        if (data.code === 200 && data.data) {
          setVideos(data.data.videos || []);
          setSelectedVideo(data.data.videos ? data.data.videos[0] : null);
          setClassInfo({
            description: data.data.description,
            resource: data.data.resource,
            duration: data.data.duration,
            instructor: data.data.instructor,
            instructor_title: data.data.instructor_title,
            about_teacher: data.data.about_teacher,
          });
        }
      })
      .catch((error) => console.error("Error fetching class data:", error))
      .finally(() => setLoading(false));
  }, [classId]);

  const handleVideoSelect = (video) => {
    setSelectedVideo(video);
  };

  const progress = videos.length > 0 ? (1 / videos.length) * 100 : 0;

  if (loading) {
    return <ClassLoading />;
  }

  return (
    <div className="class-container">
      <div className="class-container-section">
        <div className="content-section">
          <VideoSection 
            selectedVideo={selectedVideo} 
            instructor={classInfo.instructor}
            instructor_title={classInfo.instructor_title} 
          />
            
          <LessonSection 
            subtopics={videos} 
            onSelect={handleVideoSelect} 
            selectedVideo={selectedVideo} 
          />
        </div>
        <div className="content-menu-section">
          <MenuTab 
            description={classInfo.description} 
            resource={classInfo.resource}
          />

          <ClassProgress 
            subtopics={videos} 
            progress={progress} 
            duration={classInfo.duration} 
            instructor={classInfo.instructor}
            instructor_title={classInfo.instructor_title}
            about_teacher={classInfo.about_teacher} 
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PreviewClass;